export const navCopy = {
  skip_to_content: "Skip to main content",
  nav_documentation: "Documentation",
  nav_documentation_short: "开发文档",
  nav_download: "下载安装",
  nav_community: "Community",
  nav_playground: "在线运行",
  nav_playground_short: "Play",
  nav_handbook: "参考手册",
  nav_tools: "实用工具",
  nav_search_placeholder: "搜索文档",
  nav_search_aria: "Search the TypeScript site",
  // let me know if you can't make this work in your lang:
  // TypeScript X.Y [stable][between?]Z.Y[beta/rc]
  nav_version_stable_prefix: "现已可用",
  nav_version_between: ", ",
  nav_version_beta_prefix: "目前处于测试阶段。",
  nav_version_rc_prefix: "已有候选版本可供尝试。",
  nav_this_page_in_your_lang: "This page is available in your language",
  nav_this_page_in_your_lang_open: "Open",
  nav_this_page_in_your_lang_no_more: "Don't show again",
}
